import { Box, Typography } from "@mui/material";


export const BasicCard = ({ e }) => {
    const { title, value, outboxStyle } = e
    return (
        <Box sx={{ p: 2, border: '1px solid #E7E8EA', borderRadius: '8px', ...(outboxStyle ? { ...outboxStyle } : {}) }}>
            <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#000' }}>{title}</Typography>
            <Typography sx={{ fontSize: '24px', fontWeight: '600', color: '#000' }}>{value}</Typography>
        </Box>
    );
}